import * as React from 'react';
import * as cx from 'classnames';
import * as _ from 'underscore';

import { SuperCriticalComponent } from 'lib/supercritical';
import { tzmoment } from 'lib/tzmoment';
import { FocusGroup, FocusEventHandlers } from 'lib/focusGroup';

import { Abbreviation, Antipode } from 'data/models/CompassPointExtensions';

import { VesselSide, VesselSides, VesselSideDisplayName } from 'server/enums/BerthReservation';

import { NullableNumericInput } from 'portcall/numericinput/view';
import { FootmarkAssignments } from './model';

const SortedVesselSides = _.sortBy(VesselSides, side =>
    side.Id === VesselSide.TBD ? -1 : side.Id
);

export interface FootmarkAssignmentsProps {
    model : FootmarkAssignments;
    /** Default is `none`. */
    labelStyle? : 'none' | 'short' | 'full';
    tabIndex? : { startmark? : number, endmark? : number, sideto? : number };
    autoFocus? : boolean;
    isAddPortCall? : boolean;
}

export class FootmarkAssignmentsView extends SuperCriticalComponent<FootmarkAssignmentsProps> {
    readonly startmarkFocus : FocusEventHandlers;
    readonly endmarkFocus   : FocusEventHandlers;

    constructor(props : FootmarkAssignmentsProps) {
        super(props);

        const focusGroup = new FocusGroup({
            onBlur: () => this.sprops().model.CommitFootmarks()
        });
        this.startmarkFocus = focusGroup.enroll().events;
        this.endmarkFocus   = focusGroup.enroll().events;
    }

    srender({ model, labelStyle = 'none', tabIndex, autoFocus, isAddPortCall } : FootmarkAssignmentsProps) {
        const
            res = model.Reservation,
            pt = res.Itinerary(),
            berth = pt?.Location()?.Berth();

        return (
            <div className={cx("footmark-assignments", { 'port-side-vessel-has-bow-to-low-footmark': berth?.PortSideVesselHasBowToLowFootmark() })}>
                {labelStyle !== 'none' &&
                    <div className={`pc-text-smalllabel assignment-label assignment-label-${labelStyle}`}>
                        {
                            labelStyle === 'full'  ? 'Footmark Assignments' :
                            labelStyle === 'short' ? 'Footmarks' :
                            null
                        }
                    </div>
                }
                <div className="assignment-widget">
                    <div className="timeline-graphic">
                        <div className="numbers-side">
                            <div className="startmark">
                                <NullableNumericInput
                                    className="footmark-num"
                                    value={model.StartmarkNum}
                                    disabled={!model.CanEdit()}
                                    tabindex={tabIndex?.startmark}
                                    autoFocus={autoFocus}
                                    isAddPortCall={isAddPortCall}
                                    {...this.startmarkFocus}
                                />
                                <span className="footmark-uom"> {res.Footmark.UOM()}</span>
                            </div>
                            <div className="duration pc-text-smalllabel">
                                {pt && 'Staying ' + tzmoment(pt.Departure.Effective()).from(tzmoment(pt.Arrival.Effective()), true)}
                            </div>
                            <div className="endmark">
                                <NullableNumericInput
                                    className="footmark-num"
                                    value={model.EndmarkNum}
                                    disabled={!model.CanEdit()}
                                    tabindex={tabIndex?.endmark}
                                    {...this.endmarkFocus}
                                />
                                <span className="footmark-uom"> {res.Footmark.UOM()}</span>
                            </div>
                        </div>
                        <div className="line tick start-tick"></div>
                        <div className="line tick startmark-tick"></div>
                        <div className="line tick endmark-tick"></div>
                        <div className="line tick end-tick"></div>
                        <div className="line main-line"></div>
                        <div className="vessel-side">
                            <div>
                                <div className={cx("vessel-side-graphic", {
                                    'is-port':      res.SideTo() === VesselSide.Port,
                                    'is-starboard': res.SideTo() === VesselSide.Starboard,
                                    'no-vessel':    res.SideTo() !== VesselSide.Port && res.SideTo() !== VesselSide.Starboard
                                })}>
                                    {model.CanEdit()
                                    ? <select className="side-to-descr side-to-descr-edit" value={res.SideTo()} onChange={e => res.SideTo(+e.currentTarget.value)} tabIndex={tabIndex && tabIndex.sideto}>
                                        {SortedVesselSides.map(v => <option value={v.Id} key={v.Id}>{v.Name}</option>)}
                                    </select>
                                    : <span className="side-to-descr">{VesselSideDisplayName[res.SideTo()]}</span>}
                                </div>
                                <span className={cx("glyphicon glyphicon-chevron-down", {
                                    'hidden': !model.CanEdit()
                                })}></span>
                            </div>
                        </div>
                        <div className="compass-point compass-point-low">{berth && Abbreviation(berth.LowFootmarkCompassPoint())}</div>
                        <div className="compass-point compass-point-high">{berth && Abbreviation(Antipode(berth.LowFootmarkCompassPoint()))}</div>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./apps/portcall/footmarkassignments/view.tsx